/**
 * Oldest-first order for a quote list. Quote ids are uuids on the live API, so they carry no
 * order of their own (Number(uuid) is NaN, which makes a numeric sort comparator undefined).
 */
export function compareQuotesByCreation(a: { id: string; createdAt: string }, b: { id: string; createdAt: string }): number {
  const ta = Date.parse(a.createdAt);
  const tb = Date.parse(b.createdAt);
  if (Number.isFinite(ta) && Number.isFinite(tb) && ta !== tb) return ta - tb;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
